export const FORM_NAMES = {
  NICKNAME: 'nickname',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ADDRESS_TYPE: 'addressType',
  STATE: 'state',
  EMAIL: 'email',
  PHONE: 'phone',
  COUNTRY: 'country',
  COUNTRY_CODE: 'countryCode',
  CITY: 'city',
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
  ZIP_CODE: 'zipCode',
  CALLING_CODE: 'callingCode',
  COMPANY_NAME: 'companyName'
};

export const FORM_LABELS = {
  [FORM_NAMES.NICKNAME]: 'ADDRESS_NAME',
  [FORM_NAMES.FIRST_NAME]: 'CAT_EMAIL_FIRSTNAME',
  [FORM_NAMES.LAST_NAME]: 'CAT_EMAIL_LASTNAME',
  [FORM_NAMES.ADDRESS_1]: 'CAT_EMAIL_ADDRESS_1',
  [FORM_NAMES.ADDRESS_2]: 'CAT_EMAIL_ADDRESS_2',
  [FORM_NAMES.STATE]: 'CAT_EMAIL_STATE',
  [FORM_NAMES.EMAIL]: 'CAT_EMAIL_EMAIL1',
  [FORM_NAMES.PHONE]: 'CAT_EMAIL_PHONE1',
  [FORM_NAMES.COUNTRY_CODE]: 'CAT_EMAIL_COUNTRY',
  [FORM_NAMES.COUNTRY]: 'COUNTRY_REGION',
  [FORM_NAMES.CITY]: 'CAT_EMAIL_CITY',
  [FORM_NAMES.ZIP_CODE]: 'CAT_EMAIL_ZIP',
  [FORM_NAMES.CALLING_CODE]: 'CAT_EMAIL_CALLING_CODE',
  [FORM_NAMES.COMPANY_NAME]: 'COMPANY_NAME_ADDRESS_BOOK',
  ADDRESS_SB: 'AB_SBADDR',
  ADDRESS_B: 'BILLINGADDRESS',
  ADDRESS_S: 'SHIPPING_ADDRESS2'
};

export const ADDRESS_BOOK_EMAIL_REGEX =
  /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,3})+$/;

// This is the format WCS is expecting to receive
export const ADDRESS_TYPES = {
  shippingAndBilling: 'SB',
  billing: 'B',
  shipping: 'S'
};

// This is the format WCS sends in the address list
export const ADDRESS_TYPE_LABELS = {
  shippingAndBilling: 'ShippingAndBilling',
  billing: 'Billing',
  shipping: 'Shipping'
};

//constants for AVI service
export const SELECTED_ADDRESS = {
  ORIGINAL: 'original',
  SUGGESTED: 'suggested'
};
export const AVI_REQUEST_TYPE_CREATE = 'create';

export const INVALID_EMAIL_DOMAINS = [
  '@cat.com',
  '@perkins.com',
  '@solarturbines.com',
  '@progressrail.com',
  '@mwm.net',
  '@fgwilson.com',
  '@kempervalve.com',
  '@anchorcoupling.com'
];

export const TAX_CREDIT_OPTIONS = {
  YES: 'YES',
  NO: 'NO'
};

export const COMPANY_LENGTH = 14;
export const REGEX_NUMERIC = /^\d+$/;
export const REGEX_ALPHA_NUMERIC = /[^A-Za-z0-9]/g;
export const INVALID_CHARS_STR = '\\,/,<,>,[,],{,}';
export const INVALID_ZIP_CODE = /^[0-9]+$/;
export const INVALID_CHARS_REGEX = /^[^<>\\/\\{}[\]]+$/;
export const INVALID_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ADDRESS_BOOK_PATH = 'AddressBookForm';
export const ADDRESS_BOOK_FORM_NAME = 'AddressBookForm';
export const ADDRESS_BOOK_LOCATION = 'AddressBook';

export const REQUEST_TYPE = {
  addressList: 'ADDRESS_LIST',
  addressSave: 'ADDRESS_SAVE',
  addressDelete: 'ADDRESS_DELETE',
  addressVerification: 'ADDRESS_VERIFICATION'
};

export const INVALID_ADDRESSES = {
  BTO: 'BTO',
  DBSSHIPTO: 'DBSSHIPTO',
  JOBSITE: 'JOBSITE',
  DROPBOX: 'dropBoxAddress'
};

export const EVENT_OPTIONS = {
  pagePath: ADDRESS_BOOK_PATH,
  formName: ADDRESS_BOOK_FORM_NAME,
  formLocation: ADDRESS_BOOK_LOCATION
};

export const SHIPPING_AND_BILLING = 'Shipping And Billing';
export const SHIPPING = 'Shipping';
export const BILLING = 'Billing';

export const NEW_FORM_VALUES = {
  nickname: '',
  firstName: '',
  lastName: '',
  zipCode: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  country: '',
  countryCode: '',
  phone: '',
  email: '',
  addressType: ADDRESS_TYPES.shippingAndBilling,
  companyName: ''
};

export const INPUTS_MAX_LENGTH = {
  firstName: 20,
  lastName: 20,
  email: 120,
  address1: 40,
  address2: 40,
  zipCode: 10,
  city: 40,
  companyName: 150
};

export const SS_TOAST_FLAG = 'AB_TOAST';
